export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    search: '搜索',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    more: '查看更多',
    loading: '加载中...',
    noData: '暂无数据',
    backToHome: '返回首页',
    follow: '关注',
    alreadyFollow: '已关注',
    unFollow: '未关注',
    openAppDetails: '打开APP查看更多',
  },
  validation: {
    required: '{field}不能为空',
    email: '请输入有效的邮箱地址',
    phone: '请输入有效的手机号码',
  },
  error: {
    networkError: '网络错误，请检查网络连接',
    serverError: '服务器错误，请稍后重试',
    notFound: '页面不存在',
  },
  // 首页
  home: {
    title: '首页',
    welcome: '欢迎来到我们的H5落地页',
  },
  // 卡组分享页
  deckShare: {
    userId: 'id: {id}',
    stats: {
      cards: '卡片',
      pokemon: '宝可梦',
      trainers: '训练家',
      energy: '能量',
    },
    gameInfo: {
      type: '游戏类型',
      format: '标准赛制',
    },
    userAvatar: '用户头像',
    cardName: '卡片名称',
  },
  // 应用推广
  appPromotion: {
    logoAlt: '应用图标',
    openApp: '打开APP',
    downloadApp: '下载APP',
    openInBrowser: '请在浏览器中打开下载',
    cardTrade: '卡牌交易',
    topDeck: '上位卡组',
    priceEvaluation: '竞价送评',
    cardCommunity: '卡牌社区',
    gameTeaching: '游戏教学'
  },
  // 银行卡添加
  addBankCard: {
    cardNumber: '银行卡号',
    expirationDate: '有效期',
    cvv: '输入CVV',
    cvvTip: '位数字',
    submit: '确认添加',
    support: '支持的卡组织',
    safeTip: '您的信息是加密和安全的',
    confirm: '确定',
    dateTip: '请选择有效期',
    cardTip: '请输入银行卡号',
    invalidCardLength: '银行卡号有误',
    unsupportedCard: '暂不支持该卡组织的银行卡',
  },
  // 搜索榜单
  searchRanking: {
    hotCard: '热门卡牌',
    priceIncrease: '涨幅榜单',
  },
  // 个人主页
  userProfile: {
    userAvatar: '用户头像',
    userId: '用户ID: {id}',
    gameTags: '游戏标签',
    stats: {
      decks: '卡组',
      followers: '粉丝',
      following: '关注',
      posts: '帖子',
    }
  },
  // 卡包分享
  packShare: {
    increaseList: '涨幅榜单',
    rating: '评分',
    reviews: '评论',
    including: '包含卡牌',
    cardPriceFrom: '从',
    cards: '张卡牌',
    sharePack: '分享卡包',
  },
  // 卡片详情页
  cardDetail: {
    increaseList: '涨幅榜单',
    products: '商品',
    effectQA: '效果/问答',
    decks: '卡组',
    reviews: '评价',
    other: '其他',
    priceGuarantee: '价格公平保障',
    lastMonth: '最近一个月',
    appDetail: '详情在APP中查看',
    condition: '品相',
    priceTrade: '集換价格',
    priceTrend: {
      up: '上涨',
      down: '下跌'
    },
    currentPrice: '当前价格',
  },
  // 分享
  share: {
    priceTrend: '价格趋势',
    strategyInfo: '攻略信息',
    deckConstruction: '卡组构建',
    appDetail: '详情在APP中查看',
    scanQR: '扫描二维码 查看详情~',
    cardEverything: '卡牌有关的一切都在这里发生',
  },
  // 店铺
  shop: {
    userId: '用户ID: {id}',
    products: '商品',
    buyers: '买家',
    followers: '粉丝',
  },
  // 心愿单
  wish: {
    wishCount: '张',
    wishTips: '立即购买并战斗！',
  },
  // 卡册
  cardAlbum: {
    hi: 'Hi, 我是{username}',
    desc: '这是我在集换社上拥有的集换卡册~',
    cardCount: '他拥有卡数',
    totalInvestment: '他的总投入',
    currentExchangePrice: '当前集换价总价值',
    syncTitle: '一起在集换社收藏卡牌，整理图鉴吧~',
    startExchange: '开启集换之旅',
  },
};
